module.exports = __webpack_public_path__ + "assets/img/code.38db43fa.png";